import classnames from 'classnames';
import React from 'react';
import CheckBox from '../../components/Checkbox';
import { FilterableMultiSelect } from '../../components/FilterableMultiSelect/FilterableMultiSelect';
import { TagItem } from '../../components/TagItem/TagItem';
import { useMobileNotificationWidgetHandlers } from '../../helpers/widget-helpers/use-email-widget-handlers';
import { BubbleTextInput } from '../common/BubbleTextInput/BubbleTextInput';
import { EmailWidgetProps } from './EmailWidget';

export const MobileNotification = (props: EmailWidgetProps) => {
  const { isExpanded } = props;
  const {
    users,
    messageValue,
    isMessageValid,
    updateMessage,
    selectedKeys,
    updateCompanyUsersToNotify,
    isUsersToNotifyArrayValid,
    markAsFollowUpValue,
    updateMarkAsFollowUp,
  } = useMobileNotificationWidgetHandlers(props);
  return isExpanded ? (
    <div>
      <div>
        <div className="notification-label">Notification Message</div>
        <BubbleTextInput
          className={classnames(
            'notification-widget__bubble-text-input',
            'email-widget--startbots-layout',
          )}
          updateText={updateMessage}
          value={messageValue}
          editMode={true}
          onClick={() => {}}
          multiline={false}
          showTextLength={false}
          showEmojiPicker={false}
          orientation="horizontal"
          updateConfigField={updateMessage}
        />
        {!isMessageValid && (
          <div className="email-widget__email-error">
            Not Valid Notification Message
          </div>
        )}
      </div>
      <div>
        <div className="notification-label">Who to notify</div>
        <FilterableMultiSelect
          className="select-audiences"
          heading="Select Users"
          items={users}
          disableDeleting={false}
          selectedKeys={selectedKeys}
          onChange={updateCompanyUsersToNotify}
          showBadge={false}
          showSearch={false}
          isOnChangeInOnClick={true}
        />
        <div className="notification-type__mobile--tags">
          {users
            .filter(u => selectedKeys.includes(u.key))
            .map(user => (
              <TagItem
                text={user.name}
                preventDelete={false}
                key={user.key}
                onDelete={() =>
                  updateCompanyUsersToNotify(
                    selectedKeys.filter(k => k !== user.key),
                  )
                }
                icon="cross"
                className="notification-type__mobile--user-tag"
              />
            ))}
        </div>

        {!isUsersToNotifyArrayValid && (
          <div className="email-widget__email-error">
            At least one user should be selected
          </div>
        )}
      </div>

      <div className="email-widget__mark-as-follow-up">
        <CheckBox
          label="Mark conversation as follow up"
          isChecked={markAsFollowUpValue}
          onClick={() => updateMarkAsFollowUp(!markAsFollowUpValue)}
        />
      </div>
    </div>
  ) : messageValue ? (
    <div className="widget-component__collapsed-content">{messageValue}</div>
  ) : null;
};
